function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2792 2.49736C23.0166 1.52081 22.2466 0.751016 21.2702 0.488063C19.4865 0 12.3512 0 12.3512 0C12.3512 0 5.21631 0 3.43254 0.469559C2.47492 0.732234 1.6862 1.52095 1.42352 2.49736C0.954102 4.28099 0.954102 7.98 0.954102 7.98C0.954102 7.98 0.954102 11.6977 1.42352 13.4626C1.68647 14.439 2.45613 15.2088 3.43268 15.4718C5.23509 15.96 12.3515 15.96 12.3515 15.96C12.3515 15.96 19.4865 15.96 21.2702 15.4904C22.2468 15.2276 23.0166 14.4578 23.2795 13.4814C23.7488 11.6977 23.7488 7.99878 23.7488 7.99878C23.7488 7.99878 23.7676 4.28099 23.2792 2.49736ZM10.0795 11.3973V4.56272L16.0128 7.98L10.0795 11.3973Z",
  fill: "#464849"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6721 7.97998L30.4561 12.768L27.2881 7.97998H33.6721Z",
  fill: "#464849"
});

function SvgVideoupload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 16,
    viewBox: "0 0 34 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoupload);
export default __webpack_public_path__ + "static/media/videoupload.06e92caa.svg";
export { ForwardRef as ReactComponent };